import React from 'react'
import SvgIcon, { SvgIconProps } from 'components/Luxkit/SvgIcon'

function SolidShipIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m2.1 13.4 1.5 3.9c.2.4.5.6.9.6H11c.6 0 1-.4 1-1 0-.5.2-4.2.2-4.8l7.4 1.7-1.1 2.8c-.2.5 0 1.1.6 1.3.6.2 1.1 0 1.3-.6l1.5-3.9c.2-.5 0-1.1-.6-1.3h-.2l-3.1-.8V7c0-.6-.4-1-1-1h-2V3c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v3H7c-.6 0-1 .4-1 1v4.3l-3.2.7c-.5.1-.9.7-.8 1.2 0 .1.1.1.1.2ZM8 8h8v2.9l-3.8-.9h-.4l-3.8.9V8Zm12.7 11.3c-.4.1-.7.3-1 .4-.7.4-1.5.4-2.1 0-1.4-.8-3.1-.8-4.5 0-.7.4-1.5.4-2.1 0-1.4-.8-3.1-.8-4.5 0-.6.4-1.4.4-2.1 0-.3-.2-.7-.3-1-.4-.5-.2-1.1.1-1.2.7-.2.5.1 1.1.7 1.2.2.1.4.1.6.2.6.4 1.3.6 2 .6s1.4-.2 2.1-.6c.8-.4 1.8-.4 2.6 0 1.3.7 2.8.7 4.1 0 .8-.4 1.8-.4 2.6 0 1.3.7 2.8.7 4.1 0 .2-.1.4-.2.6-.2.5-.2.8-.7.7-1.2-.5-.6-1-.9-1.6-.7Z"/>
  </SvgIcon>
}

export default SolidShipIcon
